// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings_settingsContainer__ZOU8g {
  display: flex;
  flex: 1 1;
  width: 100%;
  height: calc(100vh - 56px);
  background-color: rgba(249, 250, 251, 0.4);
  overflow: hidden;
}

.Settings_mainPanel__ayqPL {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100%;
  overflow-y: auto;
  position: relative;
}

.Settings_contentWrapper__HMZz7 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5rem 2rem;
}
@media (max-width: 768px) {
  .Settings_contentWrapper__HMZz7 {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Settings/Settings.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,0CAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;AACF;AACE;EAPF;IAQI,aAAA;EAEF;AACF","sourcesContent":[".settingsContainer {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  height: calc(100vh - 56px);\n  background-color: rgba(249, 250, 251, 0.4);\n  overflow: hidden;\n}\n\n.mainPanel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: 100%;\n  overflow-y: auto;\n  position: relative;\n}\n\n.contentWrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 1.5rem 2rem;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsContainer": `Settings_settingsContainer__ZOU8g`,
	"mainPanel": `Settings_mainPanel__ayqPL`,
	"contentWrapper": `Settings_contentWrapper__HMZz7`
};
export default ___CSS_LOADER_EXPORT___;
